<!-- Task List Content -->
<div>

  <nx-pageTitle-box
    *ngIf="showPageTitle()"
    [label]="'Aufgaben'"
    [icon]="'icon-task-open'"
    [iconToolTip]="'Aufgaben'">
      <ng-template nxTemplate="end">
        <div class="mr-2 justify-end">
          <input
              #globalSearch
              pInputText
              type="text"
              class="p-inputtext p-component p-element w-[300px]"
              placeholder="Aufgabe suchen" />
        </div>
        <nx-command-button
          *ngIf="rolesService.hasRole('nexcore_task_create')"
          #taskListComp
          [reloadable]="reloadable"
          [style]="'light'"
          [commandName]="'taskCreateCommand'"
          [icon]="'icon-plus'">
        </nx-command-button>
    </ng-template>
  </nx-pageTitle-box>

  @if (showTabs()) {
    <ng-template #tabBadge let-index="index" let-label="label">
      <span>{{ label }}</span>
      @if (selectedFilter() === index) {
        <nx-count-badge [count]="totalElements()" />
      }
    </ng-template>

    <div class="flex flex-row">
      <div class="w-full">
        <p-tabView #tabView [activeIndex]="selectedFilter()" (activeIndexChange)="onFilterChange({index: $event})">
          <p-tabPanel>
            <ng-template pTemplate="header">
              <ng-container *ngTemplateOutlet="tabBadge; context: { index: 0, label: 'Offen' }"></ng-container>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel>
            <ng-template pTemplate="header">
              <ng-container *ngTemplateOutlet="tabBadge; context: { index: 1, label: 'Abgeschlossen' }"></ng-container>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel>
            <ng-template pTemplate="header">
              <ng-container *ngTemplateOutlet="tabBadge; context: { index: 2, label: 'Alle' }"></ng-container>
            </ng-template>
          </p-tabPanel>
        </p-tabView>
      </div>
    </div>
  }

  <div class="flex flex-col lg:flex-row px-[0.75rem] py-[0.4rem] leading-[1rem] bg-white gap-2" [class.border-t]="!showTabs()">
    <div class="flex flex-row flex-wrap gap-2 lg:flex-1">
      <nx-filter-multiSelect
        [className]="'table-filter'"
        [filter]="false"
        [showToggleAll]="false"
        [showHeader]="false"
        [appendTo]="'body'"
        [showClear]="true"
        placeholder="Typ"
        [ngModel]="typesModel()"
        (ngModelChange)="onTypesChange($event)"
        (onClear)="onTypesChange([])"
        [options]="typeOptions()"
        [optionValue]="'id'"
        optionLabel="label">
        <ng-template let-option pTemplate="item">
          <div class="inline-block vertical-align-middle">
            <span class="ml-1 mt-1">{{ option.name }}</span>
          </div>
        </ng-template>
      </nx-filter-multiSelect>

      <!-- Filter: Location -->
      <nx-filter-multiSelect
        [className]="'table-filter'"
        [filter]="false"
        [showToggleAll]="false"
        [showHeader]="false"
        [appendTo]="'body'"
        [ngModel]="locationsModel()"
        (ngModelChange)="onLocationsChange($event)"
        (onClear)="onLocationsChange([])"
        [options]="locationsOptions()"
        [showClear]="true"
        [placeholder]="'Niederlassung'"
        [dataKey]="'id'"
        [optionValue]="'id'"
        optionLabel="name">
        <ng-template pTemplate="selectedItems" let-locations>
          @if (locations?.length > 1) {
            Niederlassung: <span class="ml-1">{{ locations.length }} ausgewählt</span>
          } @else {
            @for (location of locations; track location.id; let isFirst = $first) {
              Niederlassung: {{ location.name }}
            }
            @empty {
              Niederlassung
            }
          }
        </ng-template>
      </nx-filter-multiSelect>

      <nx-filter-multiSelect
        [className]="'table-filter'"
        [filter]="false"
        [showToggleAll]="false"
        [showHeader]="false"
        [appendTo]="'body'"
        [options]="statesOptions"
        [ngModel]="statesModel()"
        (ngModelChange)="onStatesChange($event)"
        (onClear)="onStatesChange([])"
        [showClear]="true"
        [maxSelectedLabels]="1"
        [optionValue]="'id'"
        [optionLabel]="'name'"
        placeholder="Status">
        <ng-template let-option pTemplate="item">
          <div class="inline-block vertical-align-middle">
            {{ option?.name }}
          </div>
        </ng-template>
      </nx-filter-multiSelect>

      <nx-filter-date-select
        [className]="'table-filter'"
        [placeholder]="'rentModule.tasksComponent.filters.dueDate' | translate"
        [showIncludeOverDue]="true"
        [includeOverDueLabel]="'inkl. überfällige'"
        [ngModel]="dueDateModel()"
        (ngModelChange)="onDueDateChange($event)"
        (onClear)="onDueDateChange(null)"
        (onChange)="onDueDateChange($event)"
        optionLabel="label">
      </nx-filter-date-select>

      <nx-filter-date-select
        [className]="'table-filter'"
        [placeholder]="'rentModule.tasksComponent.filters.completed' | translate"
        [showIncludeOverDue]="false"
        [ngModel]="completedDateModel()"
        (ngModelChange)="onCompletedDateChange($event)"
        (onClear)="onCompletedDateChange(null)"
        (onChange)="onCompletedDateChange($event)"
        optionLabel="label">
      </nx-filter-date-select>
    </div>

    <div class="flex flex-row justify-start lg:justify-end">
      <nx-sort-select
        class="mr-2"
        placeholder="Sortierung"
        [appendTo]="'body'"
        [showNoSortOption]="true"
        [ngModel]="sortModel()"
        (ngModelChange)="onSortChange($event)"
        [options]="sortFields">
      </nx-sort-select>
      <nx-field-selector
        class="mr-2"
        [availableFields]="availableFields"
        [displayedFields]="displayedFields()"
        [defaultFields]="['address', 'order', 'customer', 'resources']"
        [showMetadata]="showMetadata()"
        (displayedFieldsChange)="onDisplayedFieldsChange($event)"
        (showMetadataChange)="onShowMetadataChange($event)">
      </nx-field-selector>
    </div>
  </div>

  <!-- Task List -->
  <div>
    <div>
      @for (task of tasks(); track task.id; let isLast = $last) {
        <app-task-row-v2-component
          [task]="task"
          [hideLastBorder]="isLast"
          [isLast]="isLast"
          [displayedFields]="displayedFields()"
          [showMetadata]="showMetadata()">
        </app-task-row-v2-component>
      }
      <nx-empty-box
        class="border-t"
        *ngIf="tasks().length === 0"
        [label]="'Keine Aufgaben gefunden.'">
      </nx-empty-box>
    </div>

    <!-- Pagination -->
    <nx-simple-paginator
      [currentPage]="pageNumber()"
      [pageSize]="pageSize()"
      [totalElements]="totalElements()"
      [pageSizeOptions]="[10, 20, 30]"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)">
    </nx-simple-paginator>
  </div>

</div>
